"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = exports.logLevels = void 0;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class logger {
  static log(message, threshold, where) {
    if (!message || message === "") return; //If no message, don't call anything.
    const logLevel = 0; //(indi ? indi.getLogLevelValue() : logger.logLevels.DEFAULT);
    if (logLevel <= threshold) {
      where(message);
    }
    ;
  }
  static warn(message) {
    logger.log(message, logger.logLevels.WARN, message => {
      console.log(message);
    });
  }
  static info(message) {
    logger.log(message, logger.logLevels.INFO, message => {
      console.info(message);
    });
  }
  static debug(message) {
    logger.log(message, logger.logLevels.DEBUG, message => {
      console.debug(message);
    });
  }
  static error(message) {
    logger.log(message, logger.logLevels.ERROR, message => {
      console.error(message);
    });
  }
  static value(level) {
    let levelValue = logger.logLevels.DEFAULT;
    if (level && level !== "") {
      levelValue = logger.logLevels[level];
      if (!levelValue) {
        levelValue = logger.logLevels.DEFAULT;
      }
    }
    return levelValue;
  }
}
exports.logger = logger;
// OFF|ERROR|WARN|INFO|DEBUG|ALL
// Values taken from: https://www.ibm.com/docs/en/cognos-analytics/10.2.2?topic=SSEP7J_10.2.2/com.ibm.swg.ba.cognos.ug_rtm_wb.10.2.2.doc/c_n30e74.html
_defineProperty(logger, "logLevels", {
  OFF: 100000,
  ERROR: 40000,
  WARN: 30000,
  INFO: 20000,
  DEBUG: 10000,
  ALL: 0,
  DEFAULT: 100000 //DEFAULT IS OFF
});
;
const logLevels = exports.logLevels = {
  OFF: 100000,
  ERROR: 40000,
  WARN: 30000,
  INFO: 20000,
  DEBUG: 10000,
  ALL: 0,
  DEFAULT: 100000 //DEFAULT IS OFF
};